/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>预注册列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" label-width="120px"  ref="formInline" :model="formInline"  class="user-search">

      <el-col span="6">      <el-form-item label="用户昵称" prop="nickName">
        <el-input maxlength="10"   clearable v-model="formInline.nickName" placeholder="输入用户昵称"></el-input>
      </el-form-item></el-col>


      <el-col span="6"> <el-form-item prop="phone" label="手机号码">
        <el-input maxlength=11   clearable  v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item></el-col>

      <el-col span="6">  <el-form-item prop="sex"  label="性别">
    <el-select v-model="formInline.sex" placeholder="不限">
      <el-option label="不限" value="0"></el-option>
      <el-option label="男" value="1"></el-option>
      <el-option label="女" value="2"></el-option>
    </el-select>
  </el-form-item></el-col>
  <el-col span="6"> <el-form-item prop="education" label="学历">
    <el-select v-model="formInline.education" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item></el-col>
     <el-col span="6"> <el-form-item prop="isTestAccount" label="是否测试号">
    <el-select v-model="formInline.isTestAccount" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="是" value="1"></el-option>
      <el-option label="不是" value="0"></el-option>

    </el-select>
  </el-form-item></el-col>

  <el-col span="6"> <el-form-item prop="blockStatus" label="系统拉黑">
    <el-select v-model="formInline.blockStatus" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="是" value="1"></el-option>
      <el-option label="否" value="0"></el-option>
    </el-select>
  </el-form-item></el-col>
  <el-col span="6"> <el-form-item prop="deviceBlockStatus" label="设备拉黑">
    <el-select v-model="formInline.deviceBlockStatus" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="是" value="1"></el-option>
      <el-option label="否" value="0"></el-option>
    </el-select>
  </el-form-item></el-col>

  <el-col span="6">
  <el-form-item prop="isSyncCrm" label="CRM是否导入">
    <el-select v-model="formInline.isSyncCrm" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="未导入" value="0"></el-option>
      <el-option label="已导入" value="1"></el-option>

    </el-select>
  </el-form-item></el-col>
  <el-col span="6">
  <el-form-item prop="isRepeatCrm" label="是否重复">
    <el-select v-model="formInline.isRepeatCrm" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="未重复" value="0"></el-option>
      <el-option label="已重复" value="1"></el-option>

    </el-select>
  </el-form-item> </el-col>
  <el-col span="6">  <el-form-item prop="version" label="版本号">
        <el-input  clearable v-model="formInline.version" placeholder="输入版本号"></el-input>
      </el-form-item></el-col>
      <el-col span="6">   <el-form-item prop="registerType" label="注册类型">
    <el-select v-model="formInline.registerType" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option v-for="item in PlatformTypeOptions" :label="item.label" :value="item.value" :key="item.value"></el-option>
    </el-select>
  </el-form-item></el-col>

  <el-col span="6">
      <el-form-item prop="source" label="客户来源">
    <el-select  clearable  v-model="formInline.source" placeholder="请选择" >
      <el-option v-for="(item,index) in forlist" :key="index"  :label=item.label :value=item.value></el-option>
  </el-select>
  </el-form-item></el-col>

  <el-col span="6"> <el-form-item prop="registerAddress" label="注册地区">
    <el-cascader
          v-model="formInline.registerAddress"
          :options="options123"
          @change="onChange"

          clearable></el-cascader>
      </el-form-item></el-col>
      <el-col span="6">    <el-form-item prop="registerIpAddress" label="注册ip地区">
        <el-cascader
          v-model="formInline.registerIpAddress"
          :options="options1234123"
          @change="onChanges"

          clearable></el-cascader>


</el-form-item></el-col>
<el-col span="6"><el-form-item prop="beginAge" label="年龄">

      <el-input style="width: 80px;"  clearable  v-model="formInline.beginAge" placeholder="不限"></el-input> -
      <el-form-item prop="endAge" label="">
        <el-input  clearable style="width: 80px;"   v-model="formInline.endAge" placeholder="不限"></el-input>
      </el-form-item>
  </el-form-item></el-col>
<el-form-item prop="beginCreateTime" label="创建时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginCreateTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-form-item prop="endCreateTime" label="">
        <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"  default-time="['23:59:59']"    type="datetime" placeholder="选择日期" v-model="formInline.endCreateTime" style="width: 100%;"></el-date-picker>

      </el-form-item>

    </el-col>
  </el-form-item>


<el-form-item>



</el-form-item>
<div style=" float: right;   ">
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="success" icon="el-icon-delete"
  @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="success" @click="resetForm('formInline')">重置</el-button> -->

        </div>
    </el-form>

    <!--列表-->
    <el-table id="educe-table"  ref="multipleTable"  @selection-change="handleSelectionChange"    stripe :data="listData" highlight-current-row v-loading="loading"

    @select-all="selectall"  @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">
      <el-table-column @select-all="selectall"  align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column  align="center"  style="font-size: 22px;"  prop="id" label="UID" width="110">
        <template slot-scope="scope">
          <img style="width:50%;" v-if="scope.row.isVip==1" src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
          <span style="font-size: 29px; font-weight: 600;  color: #885DDF; ">{{  scope.row.id}}</span>

        </template>
      </el-table-column>
      <el-table-column  prop="phone" label="手机" width="150">
        <template slot-scope="scope">
          <div>{{scope.row.phone,userifom|mobileStr}}</div>

        </template>
      </el-table-column>
      <el-table-column  prop="createTime"  label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.createTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="sex" label="性别" width="100">
        <template slot-scope="scope">
          <div style="color: #34D0B4;" v-if="scope.row.sex==1">男</div>
          <div  style="color: deeppink;"  v-if="scope.row.sex==2">女</div>
          <div v-if="scope.row.sex==null"></div>
        </template>
      </el-table-column>
      <el-table-column  prop="nickName" label="昵称" width="200">
      </el-table-column>
      <el-table-column  prop="age" label="年龄" width="100">
      </el-table-column>
      <el-table-column  prop="deviceId" label="设备id" width="150">
      </el-table-column>

      <el-table-column  prop="education" label="学历" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.education==7">博士后</div>
          <div v-if="scope.row.education==6">博士</div>
          <div v-if="scope.row.education==5">硕士</div>
          <div v-if="scope.row.education==4">本科</div>
          <div v-if="scope.row.education==3">大专</div>
          <div v-if="scope.row.education==2">中专</div>
          <div v-if="scope.row.education==1">中专以下</div>
        </template>
      </el-table-column>
      <el-table-column  prop="registerAddress" label="注册地区" width="250">
      </el-table-column>
      <el-table-column  prop="registerIpAddress" label="注册ip地区" width="250">
      </el-table-column>
      <el-table-column  prop="headIcon" label="头像" width="120">
        <template slot-scope="scope">
          <img style="width: 120px; height: 100px;" :src="scope.row.headIcon" alt="">
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column  prop="version" label="版本号" width="150">
      </el-table-column>
       <el-table-column  prop="isSyncCrm" label="CRM是否导入" width="150">
        <template slot-scope="scope">

          <div>{{scope.row.isSyncCrm==0?'未导入':"已导入"}} <span style="font-size: 28px;">
            {{ scope.row.syncCrmNum>0?scope.row.syncCrmNum:'' }}
          </span> </div>
        </template>
      </el-table-column>
      <el-table-column  prop="isRepeatCrm" label="是否重复" width="150">
        <template slot-scope="scope">

          <div>{{scope.row.isRepeatCrm==0?'未重复':"已重复"}}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="registerTypeDesc" label="注册类型" width="180">
      </el-table-column>
      <el-table-column   prop="status" label="系统拉黑" width="180">
        <template slot-scope="scope">
         <span>{{ scope.row.blockStatus==0?'否':'是' }}</span>
         <div v-if="scope.row.blockTimeMills" style="font-size: 16px">{{ scope.row.blockTimeMills|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column    prop="status" label="设备拉黑" width="180">
        <template slot-scope="scope">
         <span>{{ scope.row.deviceBlockStatus==0?'否':'是' }}</span>
         <div  v-if="scope.row.deviceBlockTimeMills"   style="font-size: 16px">{{ scope.row.deviceBlockTimeMills|timestampToTime }}</div>

        </template>
      </el-table-column>
      <el-table-column  fixed="right"  prop="sourceDesc" label="客户来源" width="120">


      </el-table-column>
      <el-table-column   fixed="right"  align="center"  prop="nickName" label="操作" width="120">

<template slot-scope="scope">
    <el-dropdown trigger="click" @click="handleClickDropDown('design', scope.row.id)" split-button @command="adddadad" type="primary">
管理
<el-dropdown-menu slot="dropdown" >

<el-dropdown-item  :command="beforeHandleCommand('a', scope.row)">{{scope.row.blockStatus==0?'系统拉黑':'取消系统拉黑'}}</el-dropdown-item>
<el-dropdown-item v-if="scope.row.deviceId" :command="beforeHandleCommand('d', scope.row)"> {{scope.row.deviceBlockStatus==0?'设备拉黑':'取消设备拉黑'}}</el-dropdown-item>

</el-dropdown-menu>
</el-dropdown>
</template>
</el-table-column>


      <!-- <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm"   style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"  @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;position: fixed; bottom: 50px; left: 270px;" v-if="roleId.roleId==1||roleId.roleId==2" >



      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <!-- <el-button @click="selectalls(listData)" type="primary">{{ addtitle }}</el-button>  -->
       <el-button @click="imporList" type="success">导出数据</el-button>
      <el-button @click="exporList" type="success">导入CRM</el-button>

    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input  v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input  v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <span>确定导出用户数据？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="falseDialogVisible">取 消</el-button>
    <el-button type="primary" @click="dialogVisiblexel">确 定</el-button>
  </span>
</el-dialog>
<el-dialog
  title="提示"
  :visible.sync="dialogVisiblCrm"
  width="30%"
  >
  <span>确定导入CMR？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="falseDialogVisibles">取 消</el-button>
    <el-button type="primary" @click="dialogVisiblexelss">确 定</el-button>
  </span>
</el-dialog>
<el-dialog :close-on-click-modal="false" center title="是否拉黑" @close="quxiaodialogFormVisible" width="60%"
      :visible.sync="FormVisible">
      <el-form :model="formLg" :rules="rules" ref="formLg">
        <div><span style="color: red;">*</span>设备拉黑原因:</div>


                <el-form-item label="" prop="blockStatus" v-if="typenum==2">
          <div style="color: red;">永久封号</div>
          <el-radio-group v-model="formLg.blockStatus" style="line-height: 40px;">
            <el-radio :label="1">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="2">尊敬的用户，非常抱歉，您的账号因发布恶意谩骂、侮辱类信息，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="3">尊敬的用户，非常抱歉，您的账号因恶意注册多个违规账号，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio>
            <!-- <el-radio :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio> -->
            <el-radio :label="5">尊敬的用户，非常抱歉，您的账号因发布广告宣传骚扰类违规信息，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="6">尊敬的用户，非常抱歉，您的账号因头像、资料信息虚假或冒用，永久封禁账号/设备，若有疑问，可向平台进行申诉</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="" prop="blockStatus" v-else>
          <div style="color: red;">封号一周</div>
          <el-radio-group v-model="formLg.blockStatus" style="line-height: 40px;">
            <el-radio :label="1">尊敬的用户，非常抱歉，您的账号发布色情骚扰类违规信息，封禁账号一周，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="2">尊敬的用户，非常抱歉，您的账号因发布恶意谩骂、侮辱类信息，违规信息，封禁账号一周，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="3">尊敬的用户，非常抱歉，您的账号因恶意注册多个违规账号，封禁账号一周，若有疑问，可向平台进行申诉</el-radio><br>
            <!-- <el-radio :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，封禁账号一周，若有疑问，可向平台进行申诉</el-radio> -->
           <div style="width: 100%;  height: 50px;"></div>

            <el-radio :label="4">尊敬的用户，非常抱歉，您的账号因发布色情骚扰类违规信息，永久封禁登入账号。若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="5">尊敬的用户，非常抱歉，您的账号因发布广告宣传骚扰类违规信息，永久封禁登入账号，若有疑问，可向平台进行申诉</el-radio>
            <el-radio :label="6">尊敬的用户，非常抱歉，您的账号因头像、资料信息虚假或冒用，永久封禁登入账号，若有疑问，可向平台进行申诉</el-radio>

          </el-radio-group>
          <div style="width: 100%;height: 20px; color:red; position: absolute; top: 48%; left: 0;">永久封号</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="QQFormVisible">取 消</el-button>
        <el-button type="primary" @click="OnsubmitFormLg('formLg')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave,deptDelete,platformAccount} from '../../api/userMG'
import {mobileStr}from "../../utils/util"
import Axios from 'axios'
import { login } from "../../api"
import Vue from 'vue'
import { homeData } from '../../request/home'


import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      roleId:"",
      addtitle:'全选',
      formLg: {
        blockStatus: '',
        deviceId:'',
        type:'',
        toAccountId:'',

      },
      dialogVisible: false,
      ssoServer:"",
      dialogVisiblCrm:false,
      dialogVisibles:false,
      options123 : [],
      FormVisible:false,
      options1234123:[],
      forlist:[],
      importListsss:'',
      ifShowbar:1,
      adder:"",

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      // userifom:"",
      options: [
      {
          value: 0,
          label: '不限'
        },
      {
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        },{
          value: 6,
          label: '博士'
        },{
          value: 7,
          label: '博士后'
        }],
        source:[{
          value: 1,
          label: '网站注册'

        },{
          value: 2,
          label: '人工录入'

        },{
          value: 3,
          label: '资源导入'

        },{
          value: 4,
          label: '相亲活动'

        },{
          value: 5,
          label: '手机来电'

        },{
          value: 6,
          label: '表单填写'

        },{
          value: 7,
          label: '到店咨询'

        }],
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      userifom:"",
      formInline: {
        isRepeatCrm:"",
        isSyncCrm:'',
        isTestAccount:"",
        beginCreateTime:"",
        endCreateTime:"",
        blockStatus:'',
        endRegisterTime:"",
        registerAddress:'',
        version:"",
        deviceBlockStatus:'',
        education:"",
        registerIpAddress:"",
        beginRegisterTime:"",
        source:"",
          sex:'',
        nickName:"",
        searchType:1,
        phone:"",
        beginAge:"",
        endAge:"",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },


  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');

    this.adder =tokenId



    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    this.getAddress()
    this.getAddresss()
    this.ongetAddress()
    this.userifom= localStorage.getItem('userifom');

   },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    QQFormVisible(){

      this.FormVisible=false

    },
    OnsubmitFormLg(formLg) {
      this.$refs[formLg].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          platformAccount({
            deviceId:this.formLg.deviceId,
            blockStatus: this.formLg.blockStatus,
            toAccountId:this.formLg.toAccountId,
            type:this.typenum
          }).then(res => {

            if (res.code == 0) {
              this.FormVisible = false
              this.$message({
                type: 'success',
                message: '拉黑成功'
              })
              this.formLg.blockStatus=''
              this.formLIst()
            } else {
            }

          })
          setTimeout(() => {
            loading.close();
          }, 500);




        } else {

          console.log('error submit!!');
          return false;
        }
      });
    },


    beforeHandleCommand(flag, command) { // flag为传递的参数
  return {
     'flag': flag,
     'command': command
  }
},
//     mobileStr(str,index) {
//       if(index==1||index==2||index==3||index==8||index==10){
//         return str
//       }else{
//         return  String(str).substring(0,3)+"****"+String(str).substring(7,4);
//       }
// },

adddadad(command){
        if(command.flag=='a'){
          this.typenum=1
          this.formLg.deviceId=command.command.deviceId,
       this.formLg.toAccountId=command.command.id
           if(command.command.blockStatus!=0){

        this.$confirm('是否将该用户的状态设为取消系统拉黑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          platformAccount({
            deviceId:this.formLg.deviceId,
            blockStatus: 0,
            toAccountId:this.formLg.toAccountId,
            type:1
          }).then(res => {
            if (res.code == 0) {
              this.FormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.formLg.blockStatus=''
              this.formLIst()
            } else {
            }

          })
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

           }else{
            this.FormVisible=true
           }



        }else if(command.flag=='c'){
          Axios({
        method: 'get',
        url: this.ssoServer+'/api/orders/getRefundList',

        headers:{
          tokenId:this.adder
        },
        params:{
          accountId:command.command
        }

      }).then(res => {

        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }

        this.getRefundList = res.data.data.list
        // this.fffamount =res.data.data.list.amount
      })
      this.form.accountId=command.command
      this.dialogFormVisible=true
      this.$nextTick(() => {
      this.$refs['form'].clearValidate();
    })

        }else if(command.flag=='b'){
          this.$router.push({
    path:"/goods/userGoods",
    query:{ //query是个配置项
        id:command.command
    }
})


        }else if(command.flag=='d'){

          this.typenum=2
       this.formLg.deviceId=command.command.deviceId,
       this.formLg.toAccountId=command.command.id

      //  console.log(command);
           if(command.command.deviceBlockStatus!=0){

        this.$confirm('是否将该用户的状态设为取消设备拉黑?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          platformAccount({
            deviceId:this.formLg.deviceId,
            blockStatus: 0,
            toAccountId:this.formLg.toAccountId,
            type:2
          }).then(res => {

            if (res.code == 0) {
              this.FormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.formLg.blockStatus=''
              this.formLIst()
            } else {
            }

          })
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

           }else{
            this.FormVisible=true
           }


        }

    },

    ongetAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/source-config/getList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        this.forlist =res.data.data
      })

    },

    falseDialogVisible(){
      this.dialogVisible=false

    },
    falseDialogVisibles(){
      this.dialogVisiblCrm=false

    },
    dialogVisiblexel(){
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/exportExcel',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importListsss,
   searchType:1
 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = '预注册列表'
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})
this.formInline.current=1
this.ifShowbar=1
this.importList=[]
            this.formLIst()
             this.dialogVisible=false
          loading.close();
        }, 500);
    },
    dialogVisiblexelss(){
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/importCrm',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importListsss,
   searchType:1
 },


}).then(res => {
  if(res.data.code==0){
    this.$message({
              type: 'success',
              message: '导入成功'
            })
            this.formInline.current=1
            this.ifShowbar=1
            this.importList=[]
            this.formLIst()
    this.dialogVisiblCrm=false
  }


})

          loading.close();
        }, 500);




    },


    selectall(val){
        // console.log(val);

      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importListsss=data
        // console.log(this.importList);

      })

      // this.importList
    // console.log(val);
    },


    getAddress(){

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',

        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.options123 = res.data.data

      })
    },

    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },


    selectallsif(){
      this.ifShowbar=1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList=[]
    },

    selectalls(rows) {


      if (rows) {
        let data =[]
        rows.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        // console.log('1212112');
        this.importList=[]
        this.$refs.multipleTable.clearSelection();//清除全选
      }
       this.ifShowbar=2


    },

              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                console.log(e);
                let adder =e[1]
                this.formInline.registerIpAddress=adder
                // this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    // selectall(val){

    //   let data =[]
    //   val.forEach((item)=>{
    //     data.push(item.id)
    //     this.importList =data
    //     console.log(this.importList);

    //   })

    //   // this.importList
    // console.log(val);
    // },
    handleSelectionChange(val) {
        this.importList = val;
      },
    // 导出数据
    imporList(){

      if(this.importList.length==0){
        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      }else{
        this.dialogVisible=true
      }

    },
    exporList(){

if(this.importList.length==0){
  this.$message({
    type: 'warning',
    message: '请选择要导入的数据'
  })
  return

}else{
  this.dialogVisiblCrm=true
}

},

    select(selection, row){

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


    formLIst(){

      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'/api/platform-account/accountList',
  headers:{
          tokenId:this.adder
        },
  params:this.formInline


}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list
      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  // console.log(res);
})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
      // if(this.formInline.beginAge<18){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能小于18'
      //           })
      //           return

      // }else if(this.formInline.endAge>80){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能大于80'
      //           })
      //           return
      // }

this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/goods/Goods.vue